module.exports = __webpack_public_path__ + "static/media/VectorUser.f653dfa9.svg";